import { DECIMAL_PLACES } from 'common/config/app';
import { getBooleanValue, parseDatabaseValue } from 'utilities';
import { ParseCellValueParams } from './types';

const parseCellValue = <T>(params: ParseCellValueParams<T>) => {
  const { cell, fieldDecimalPlaces } = params;

  const { allowEmptyValues, dbDecimalPlaces, dbType, defaultValue, format, gridType, value } = cell;

  const decimalPlaces = fieldDecimalPlaces ?? dbDecimalPlaces ?? DECIMAL_PLACES;

  const x = parseDatabaseValue({
    allowEmptyValues: getBooleanValue(allowEmptyValues),
    decimalPlaces,
    format,
    gridType,
    type: dbType,
    value: value ?? defaultValue ?? null,
  });

  return x;
};

export default parseCellValue;
